/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkDunningLevelsResetDto
 */
export interface BulkDunningLevelsResetDto {
    /**
     * A list of contract IDs for which the dunning levels will be reset
     * @type {Set<number>}
     * @memberof BulkDunningLevelsResetDto
     */
    contractIds: Set<number>;
}

/**
 * Check if a given object implements the BulkDunningLevelsResetDto interface.
 */
export function instanceOfBulkDunningLevelsResetDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contractIds" in value;

    return isInstance;
}

export function BulkDunningLevelsResetDtoFromJSON(json: any): BulkDunningLevelsResetDto {
    return BulkDunningLevelsResetDtoFromJSONTyped(json, false);
}

export function BulkDunningLevelsResetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDunningLevelsResetDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contractIds': json['contractIds'],
    };
}

export function BulkDunningLevelsResetDtoToJSON(value?: BulkDunningLevelsResetDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contractIds': Array.from(value.contractIds as Set<any>),
    };
}

